export type MixinConstructor<T = {}> = new (...args: any[]) => T;
/**
 * https://www.typescriptlang.org/docs/handbook/mixins.html
 * We are using the default pattern. Alternative pattern described later in the doc doesn't work well with inherited properties
 */
